import Dimens from 'src/core/utils/Dimens';

const GRID_INSET = Dimens.padding18 * 2;
const COLUMNS = 2;
const LAST_STAGGERED_CARD = 7;

export const gridColumnWidth = (windowWidth: number) => (windowWidth - GRID_INSET - Dimens.gap16) / COLUMNS;

export const gridEnterDelay = (index: number) => Math.min(index, LAST_STAGGERED_CARD) * Dimens.animationDelay40;
